import { createContext } from 'preact/compat';

export default createContext(null);
